/* eslint-disable no-use-before-define,jsx-a11y/role-has-required-aria-props */

import React from 'react'
import { Flyout, getId, } from '../twd'

export default ({field, form, label, info, ...props}={}) => {
    const id = getId()

    return (
    <div className="checkbox">
        <input
            id={id}
            type="checkbox"
            checked={field.value || false}
            {...field}
            {...props} />
        <label htmlFor={id}>{label}</label>
        &nbsp; {info && <Flyout html={info} />}
    </div>
    )
}
